











import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { Prop } from 'vue-property-decorator'
import { BasicCampaignCollectionModel } from '@/modules/base-campaign/models/base-campaign-collection.model'

@Component({
  components: {
    BaseButton
  }
})
export default class BaseCampaignsTableActions extends Vue {
  @Prop({ required: true }) campaignResource: BasicCampaignCollectionModel
}
